<template>
<body style="--num:12;" v-show="startRender">
    <a href="javascript:window.history.back();" class="close"><i class="xi-close-circle-o"></i></a>
    <div class="modal winner">
      <div class="modal-in">
        <a  class="close"></a>
        <template v-if="gameResult.winInfo != undefined">
            <h2><span>{{ gameResult.winInfo.name }} </span>당첨!!</h2>
            <div class="cont">
                <p>축하합니다. {{ gameResult.winInfo.name }}에 당첨되셨습니다.</p>
                <div class="img">
                    <img :src="`${gameResult.winInfo.imageUrl}`">
                </div>
            </div>
        </template>
        <template v-else>
            <h2><span>참여 보상 </span>당첨!!</h2>
            <div class="cont">
                <p>축하합니다. 참여 보상에 당첨되셨습니다.</p>
                <div class="img">
                    <img src="images/favicon/android-icon-192x192.png">
                </div>
            </div>
        </template>
      </div>
    </div>
    <div class="help">
      <div class="open">
        <ul class="caution">
          <li class="title">유의사항</li>
          <li v-for="(notice , index) in noticeList" :key="index"> {{notice}}</li>
          <!--
          <li>룰렛은 경품전달을 위한 정보를 입력 후 시작 할 수 있습니다.</li>
          <li>당첨된 상품은 문자발송되며, 해당 매장 주문시 사용 가능합니다.</li>
          <li>1일 당첨수량이 모두 소진된 뒤에는 당첨이 더 이상 이루어지지 않을 수 있습니다.</li>
          <li>본 이벤트는 당사 사정에 의해 사전고지 없이 변경 및 종료될 수 있습니다.</li>
          <li>부적절한 방법 (ID도용, 불법프로그램) 을 통해 이벤트 응모, 당첨 시 당첨은 취소되며 법적인 처벌을 받을 수 있습니다.</li>
          -->
        </ul>
      </div>
      <a  class="toggle"></a>
    </div>
    <div class="kiosk">
      <div class="header top">
        <div class="header_bg">
          <h2 class="date">돌리기만 해도 무조건 채굴!</h2>
          <h1 class="title">오늘도 한번 <span>더해</span></h1>
        </div>
        <p>친구를 더하고 게임을 더 했더니 코인과 혜택이 덤으로!<br>그래서 난 오늘도 한번 더해 !!</p>
        <div class="mine-t">
            <template v-if="check == true">
                <h4 class="remain"><span>채굴권 획득 가능!</span> <div class="get" @click="startNativeAd()">채굴권 받기</div></h4>
            </template>
            <template v-else>
                <h4 class="remain"><span>{{timeText}}</span>후에 채굴권 획득 가능(보유: {{ticketCnt}})</h4>
            </template>

          <!-- <h4 class="remain"><span>06:58:32</span>후에 채굴권 획득 가능(보유: 24.55)</h4> -->
          <!--<h4 class="remain"><span>채굴권 획득 가능!</span> <a href="#" class="get">채굴권 받기</a></h4>-->
        </div>
      </div>
      <div class="winning">
        <canvas id="canvas" width="414" height="896"></canvas>
      </div>
      <div class="roulette mid">
        <div class="pan"></div>
        <div class="bg"></div>
        <div class="spinner">
          <div class="start">
            <p class="start_btn">
              <a  class="open-success">GO<em>!</em></a>
            </p>
          </div>
          <div class="circle">
            <!--룰렛판-->
            <div class="items">
            <div v-for="(item , index) in itemList" :key="index" :class="item.soldout == 'Y' ? 'item soldout' : 'item'">
                <p class="name">{{ item.name }}</p>
                <p class="icon"><img :src="`${item.imageUrl}`" alt=""></p>
            </div>

                <!--
              <div class="item sale">
                <p class="name">쁘띠성형 시술권<span class="dc_value">20%</span> 할인</p>
                <p class="icon sale">20%</p>
              </div>
              <div class="item soldout">
                <p class="name">턱보톡스 이용 시 윤곽주사 무료 이용권과 무료주차권</p>
                <p class="icon"><img src="images/icons/icon_coffee.png" alt=""></p>
              </div>
              <div class="item">
                <p class="name">
                  <span class="dc_value">20%</span><br>
                  할인 쿠폰
                </p>
                <p class="icon"><img src="images/icons/icon_cart.png" alt=""></p>
              </div>
              <div class="item">
                <p class="name">
                  아쉽습니다<br>
                  꽝이네요
                </p>
                <p class="icon"><img src="images/icons/icon_failed.png" alt=""></p>
              </div>
              -->
              
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="current-point">
          <div class="sect">
            <h4>보유 FUS</h4>
            <h5>{{ accountCoinView }}</h5>
          </div>
          <div class="sect">
            <h4>보유 채굴권</h4>
            <h5>{{ ticketCntView }}</h5>
          </div>
        </div>
      </div>
      <div class="log">
        <ul class="list">
          <li v-for="(user, index) in resultList" :key="index" :class="user.winnerType == 'WIN' ? 'winner' : ''">
            <div class="profile" :style="`background-image: url(${user.userInfo.myPhotoUrl}), url(/images/basic/img/default.svg) ;border-radius:50%`"></div>
            <div class="infos">
              <p>{{user.joinText}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--<script type="text/javascript" src="js/commonV2.js"></script>-->
</body>
</template>

<script>
import $ from 'jquery';
import Vue from 'vue';
import VueHead from 'vue-head';
import { timeCheck ,create, use, check } from '@/api/mining'
//import * as commonScript from '@/js/commonV2.js';

Vue.use(VueHead)
export default {
  head: {
    title: {
      inner: '더해-블록체인 커뮤니티 플랫폼'
    },
    meta: [
      { charset: 'UTF-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover' },
      { name: 'apple-mobile-web-app-title', content: '더해' },
      { name: 'apple-mobile-web-app-capable', content: 'yes' },
      { name: 'msapplication-TileColor', content: '#ffffff' },
      { name: 'theme-color', content: '#ffffff' },
      { name: 'msapplication-TileImage', content: '/ms-icon-144x144.png' },
      { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
      { property: 'og:url"', content: '' },
      { property: 'og:title"', content: '더해' },
      { property: 'og:type"', content: 'website' },
      { property: 'og:image"', content: 'images/favicon/og.png' },
      { property: 'og:description"', content: '즐거움과 혜택이 더해지는 커뮤니티 플랫폼' },
    ],
    link: [
      { rel: 'stylesheet', type: 'text/css', href: 'stylesheets/jquery.bxslider.css' },
      { rel: 'stylesheet', type: 'text/css', href: 'stylesheets/commonV2.css?v=2' },
      { rel: 'stylesheet', type: 'text/css', href: 'roulette-thehae/css/current.css?v=2' },
      
      { rel: 'apple-touch-icon', sizes: '57x57', href: 'images/favicon/apple-icon-57x57.png' },
      { rel: 'apple-touch-icon', sizes: '60x60', href: 'images/favicon/apple-icon-60x60.png' },
      { rel: 'apple-touch-icon', sizes: '72x72', href: 'images/favicon/apple-icon-72x72.png' },
      { rel: 'apple-touch-icon', sizes: '76x76', href: 'images/favicon/apple-icon-76x76.png' },
      { rel: 'apple-touch-icon', sizes: '114x114', href: 'images/favicon/apple-icon-114x114.png' },
      { rel: 'apple-touch-icon', sizes: '120x120', href: 'images/favicon/apple-icon-120x120.png' },
      { rel: 'apple-touch-icon', sizes: '144x144', href: 'images/favicon/apple-icon-144x144.png' },
      { rel: 'apple-touch-icon', sizes: '152x152', href: 'images/favicon/apple-icon-152x152.png' },
      { rel: 'apple-touch-icon', sizes: '180x180', href: 'images/favicon/apple-icon-180x180.png' },
      { rel: 'icon', type: 'image/png', sizes: '192x192', href: 'images/favicon/android-icon-192x192.png' },
      { rel: 'icon', type: 'image/png', sizes: '32x32', href: 'images/favicon/favicon-32x32.png' },
      { rel: 'icon', type: 'image/png', sizes: '96x96', href: 'images/favicon/favicon-96x96.png' },
      { rel: 'icon', type: 'image/png', sizes: '16x16', href: 'images/favicon/favicon-16x16.png' },
    ],
    script: [
      { type: 'text/javascript', src: 'javascripts/js/jquery-3.4.1.js'},
      { type: 'text/javascript', src: 'javascripts/js/commonV2.js'},
      { type: 'text/javascript', src: 'javascripts/js/jquery.bxslider.js'}
    ]
  },
  data() {
     return{
        startRender:false,

        ticketCntView:"",
        tempTicketCnt:0, // 내 티켓 카운트
        //gameResult:[], // 주사위 RESULT
        timeText:"",     // 채굴권 흭득 가능시간 TEXT
        second:0,        // 채굴권 흭득 가능시간 second
        check:false,     // ?TODO

        // check
        gameResultIcons:["thehae","grape","bell","jwel","money","seven","clover","heart","bonus"],
        eventInfo:{},  // 이벤트 정보
        itemList:[],   // 룰렛 아이템 정보
        accountCoinView:"", // 내 보유fus 콤마처리
        resultList:[], // 참여자 정보

        // use
        plusAmount:0,    // 증가하는 fus
        gameResult:{},   // 룰렛 결과

        // spin value
        spinEnable:true,

        noticeList:[
          "사용자가 참여하여 해당 아이템을 채굴하는 게임입니다.","당첨된 FUS는 바로 지급되어 합산됩니다.","보유한 채굴권을 모두 소진시까지 참여가 가능합니다.",
          "비정상적 방법을 이용한 경우 획득한 FUS는 모두 회수됩니다.","당첨된 상품은 핸드폰 번호(카카오톡 또는 문자)로 발송됩니다.","당사 사정에 의해 사전고지 없이 상품 변경이 이루어 질 수 있습니다."
        ],

     }
  },
  created() {
     // remove common css 
    if($('link[href*="/stylesheets/reset.css"]')[0])$('link[href*="/stylesheets/reset.css"]')[0].remove();
    if($('link[href*="/stylesheets/style.css"]')[0])$('link[href*="/stylesheets/style.css"]')[0].remove();

    this.adTimeCheck();
    this.checkList();

    setTimeout(function(){
        //window.VueRoot.startRender = true;
    },700);
    
  },
  mounted() {
    window.VueRoot=this;
    $('.open-success').click(function () {
        if(!window.VueRoot.spinEnable) return;
        if(window.VueRoot.ticketCnt < 1) {
            alert("채굴권이 부족합니다.");
            return;
        }
        window.VueRoot.spinEnable = false;
        window.VueRoot.useTicket();
    });
    $( '.modal .close' ).click( function () {
        $( 'body' ).removeClass( 'modal-poped ' );
        $( '.winning' ).removeClass( 'on ' );
        $( '.circle' ).css( {
            'transition': '',
            'transform': ''
        } );
    });

    const AudioContext = window.AudioContext || window.webkitAudioContext;
    const audioCtx = new AudioContext();

  },
  computed: {
      accountCoin(){
         var accountCoin = this.$store.state.userInfo.accountCoin == undefined ? 0 : this.$store.state.userInfo.accountCoin;
         return accountCoin;
      },
      ticketCnt(){
         if(this.$store.state.userInfo.ticketCnt == undefined){
            return 0;
         }else{
            return this.$store.state.userInfo.ticketCnt;
         }
      },
      fusAmount(){
        var fusStr = "0.1";
        /*
        if(this.gameResult.length > 0){
          if(this.gameResult.every(v => v === this.gameResult[0])){
            fusStr = "10만"
          }
        }
        */
        return fusStr;
      }
  },
  methods: {
    addScript() {
      let scripts = [ ];
      for (let i = 0, len = scripts.length; i < len; i++) {
        let script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', scripts[i]);
        script.async = false;
        document
        .getElementsByTagName('body')[0]
        .appendChild(script)
      }
    },
    startNativeAd(){
       var varUA = navigator.userAgent.toLowerCase();
        console.log(varUA);
        console.log("=============");
       if ( varUA.indexOf('android') > -1) {
           //ANDDROID
           try{
              window.Android.platInterstitialAd("AD1");
           }catch{
              window.Android.playRewardAd();  
           } 
       } else if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
           //IOS
           window.webkit.messageHandlers.platInterstitialAd.postMessage("AD1");
       } else {
           //아이폰, 안드로이드 외
         
       }
    },
    adTimeCheck(){
       timeCheck({
          adType:"AD1"
       })
       .then(({ data }) => {
          this.check = data.check;
          this.second = data.second;
          if(this.second>0){
             this.uiSetTimeText(); 
          }
       })
    },
    uiSetTimeText(){
       this.interval = setInterval(function(){
	       window.VueRoot.second--;
          var sec_num = window.VueRoot.second; // don't forget the second param
          var hours   = Math.floor(sec_num / 3600);
          var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
          var seconds = sec_num - (hours * 3600) - (minutes * 60);
          if (hours   < 10) {hours   = "0"+hours;}
          if (minutes < 10) {minutes = "0"+minutes;}
          if (seconds < 10) {seconds = "0"+seconds;}
          var timeTextStr = hours+":"+minutes+":"+seconds;
          window.VueRoot.timeText = timeTextStr;
          if(sec_num < 0) {
             clearInterval(window.VueRoot.interval);
             window.VueRoot.adTimeCheck();
          }
	    },1000);
    },
    useTicket(){
       use({
          gameType:"roulette",
       })
       .then(({ data }) => {
            if(data.resultCode == 1000){
                this.plusAmount = data.plusAmount;
                this.gameResult = data.gameResult;
                this.tempTicketCnt = data.ticketCnt;
                this.ticketCntView = data.ticketCntView;
                window.VueRoot.$store.commit('udtTicketCnt', window.VueRoot.tempTicketCnt);
                window.VueRoot.playSpin();
            }else if(data.resultCode == 2100){
                alert("채굴권이 부족합니다.")
            }
       })
    },
    /**
     * 모바일에서 광고 시청이 완료되었을때 불리는 function
     * do ticket add rest ful apu call
     * native => Vue 
     * @adType = "AD1","AD2","AD3" // 해당 값은 일단 유동적으로
     *            각게임마다 정해진 AD<NUM> 사용해볼것
     */
    addTicketCnt(adType){
       create({
          adType:"AD1"
       })
       .then(({ data }) => {
          //this.ticketCnt = data.ticketCnt;
          this.$store.commit('udtTicketCnt', data.ticketCnt);
          this.adTimeCheck();
          this.checkList();
          
       })
    },
    /**
     * 채굴권 갯수 확인 및 참여리스트 
     */
    checkList(){
       check({
          gameType:"roulette"
       })
       .then(({ data }) => {
            console.log(data);
            this.ticketCntView = data.ticketCntView;
            this.$store.commit('udtAccountCoin', data.accountCoin);
            this.eventInfo = data.eventInfo;

            this.itemList = data.itemList;
            this.accountCoinView = data.accountCoinView;
            this.resultList = data.resultList;

            this.startRender = true;
            this.cercleInit(data.itemList ? data.itemList.length : 0);
           
       })
    },
    cercleInit(length){
        //룰렛갯수파악
        $( 'body' ).css( '--num', length == 0 ? 6 : length );
    },

    script(){
        $( ".help" ).click( function ( e ) {
            $( this ).toggleClass( "ed" );
        });
        "use strict";
        
    },
    playTick(playTime){
      setTimeout(function () {
        var tick_sound = new Audio("ringtones/tick_v2.mp3");
        tick_sound.play();
      },playTime);
    },

    playSpin(){
        $('.kiosk .roulette .spinner .start p a').html("채굴중");
        var times = 10;
        var pie = 360;

        var angle = parseFloat(this.gameResult.randomAngle);
        if(isNaN(angle)) { angle = Math.floor(Math.random() * 360); }

        var target = /*angle + */(times * pie) - angle; //회전각도 // /*Math.floor(Math.random() angle * 360)*/ 

        var duration = 8; //회전시간 단위 초
        var timer = duration * 1000 + 1000;
      
        console.log($(".circle"));
        $('.circle').css({
            'transition': duration +'s ease-in-out',
            'transform': 'rotate(' + target + 'deg)'
        });

        var count = 0;        
        this.r_interval = setInterval(function(){
            var matrix = $('.circle').css('transform');
            var values = matrix.split('(')[1].split(')')[0].split(',');
            var angle = Math.round(Math.atan2(values[1], values[0]) * (180/Math.PI));
            if(angle < 0) angle +=360;
            var innerCount = Math.floor(angle/45)
            if(count != innerCount){
              window.VueRoot.playTick(0);
            }
            count = innerCount;
	      },5);
        /*
        for(var j=0; j<35 ; j++){
          if(j*100 > 2500){
            if((j*100)%200 == 0){
              window.VueRoot.playTick(j*100);
            }
          }else if(j*100 > 3500){
            if((j*100)%300 == 0){
              window.VueRoot.playTick(j*100);
            }
          }
          else if(j*100 > 4500){
            console.log("== stop");
          }else{
            window.VueRoot.playTick(j*100);
          }
        }
        */
       setTimeout(function () {
            clearInterval(window.VueRoot.r_interval);
        }, timer-1500);
        
        setTimeout(function () {
            $( 'body' ).addClass( 'modal-poped ' );
            $( '.winning' ).addClass( 'on ' );

            $( '.kiosk .roulette .spinner .start p a' ).html( 'GO<em>!</em>' );

            window.VueRoot.spinEnable = true;
            window.VueRoot.checkList();
            clearInterval(window.VueRoot.r_interval);
        }, timer);
    }
   }
}
</script>

<style>

</style>